module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Auenstein_AG-8282c81960536f4aa15be34c53237904.svg";